import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../../../../app/GetProxy";
import { handleResponseCode } from "../../../../../app/utilities/helpers";


const proxy = GetProxy()
const cookies = new Cookies();


export const getProjectJiraList = createAsyncThunk(
  "post/getProjectJiraList",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { payload, pageNumber, itemsPerPage } = props;
      const response = await fetch(`${proxy}/cmdb/api/v1/jiraProjectListRest/getJiraProjectDetailsListWithCount/${pageNumber}/${itemsPerPage}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      });
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);


export const getProjectGitLabList = createAsyncThunk(
  "post/getProjectGitLabList",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { payload, pageNumber, itemsPerPage } = props;
      const response = await fetch(`${proxy}/cmdb/api/v1/gitlab/getGitlabProjectDetailsListWithCount/${pageNumber}/${itemsPerPage}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      });
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const getProjectSonarCubeList = createAsyncThunk(
  "post/getProjectSonarCubeList",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { payload, pageNumber, itemsPerPage } = props;
      const response = await fetch(`${proxy}/cmdb/api/v1/sonarProjectDetails/getSonarQubeProjectDetailsListWithCount/${pageNumber}/${itemsPerPage}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      });
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);


const ProjectsSlice = createSlice({
  name: "projects",
  initialState: {
    projectJiraListLoading: false,
    projectJiraListData: [],
    projectGitLabListLoading: false,
    projectGitLabListData: [],
    projectSonarCubeListLoading: false,
    projectSonarCubeListData: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProjectJiraList.pending, (state, action) => {
        state.projectJiraListLoading = true;
      })
      .addCase(getProjectJiraList.fulfilled, (state, action) => {
        state.projectJiraListData = action.payload;
        state.projectJiraListLoading = false;
      })
      .addCase(getProjectJiraList.rejected, (state, action) => {
        state.projectJiraListLoading = false;
        state.projectJiraListData = [];
      })
      .addCase(getProjectGitLabList.pending, (state, action) => {
        state.projectGitLabListLoading = true;
      })
      .addCase(getProjectGitLabList.fulfilled, (state, action) => {
        state.projectGitLabListData = action.payload;
        state.projectGitLabListLoading = false;
      })
      .addCase(getProjectGitLabList.rejected, (state, action) => {
        state.projectGitLabListLoading = false;
        state.projectGitLabListData = [];
      })

      .addCase(getProjectSonarCubeList.pending, (state, action) => {
        state.projectSonarCubeListLoading = true;
      })
      .addCase(getProjectSonarCubeList.fulfilled, (state, action) => {
        state.projectSonarCubeListData = action.payload;
        state.projectSonarCubeListLoading = false;
      })
      .addCase(getProjectSonarCubeList.rejected, (state, action) => {
        state.projectSonarCubeListLoading = false;
        state.projectSonarCubeListData = [];
      })
  },
});
export const { } = ProjectsSlice.actions;
export default ProjectsSlice.reducer;